export function SET_TYPE(type) {
    return {
        type: 'SET_TYPE',
        payload: type
    }
}

export function SET_PROFILE_OPEN(status) {
    return {
        type: 'SET_PROFILE_OPEN',
        payload: status
    }
}

export function SET_LIKES_POPUP_ACTIVE(status) {
    return {
        type: 'SET_LIKES_POPUP_ACTIVE',
        payload: status
    }
}